import { render, staticRenderFns } from "./bigSortNew.vue?vue&type=template&id=4404d029"
import script from "./bigSortNew.vue?vue&type=script&lang=js"
export * from "./bigSortNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports